import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { DialogRef, DIALOG_DATA } from 'src/app/shared/services/dialog.service';
import { DialogInputConfig, DialogResult } from 'src/app/shared/models/dialog-input';

@Component({
    selector: 'app-dialog-input',
    templateUrl: './dialog-input.component.html',
    styleUrls: ['./dialog-input.component.scss'],
    standalone: false
})
export class DialogInputComponent implements OnInit {
  inputValue: string = "";

  constructor(
    public dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public config: DialogInputConfig) { }

  ngOnInit() {
    this.config.title = this.config.title  || 'Confirm';
    this.config.cancelText = this.config.cancelText  || 'No';
    this.config.confirmText = this.config.confirmText  || 'Yes';
    this.config.maxInputLength = this.config.maxInputLength || 50;
  }

  isValidForm(inputValue) {
    return !this.config.inputEnabled || (this.config.inputEnabled && inputValue && inputValue.length > 0);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onConfirmClick(inputValue: string){
    let result: DialogResult = {
      value: true
    };

    if(!this.config.inputEnabled){
      this.dialogRef.close(result);
    } else{
      result.value = inputValue;
      this.dialogRef.close(result);
    }
  }

}
